import { render } from "./EmailField.vue?vue&type=template&id=46ba000a"
import script from "./EmailField.vue?vue&type=script&lang=js"
export * from "./EmailField.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"EmailField.vue"]])

export default __exports__